import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';
// import animationData from '../lotties/4203-take-a-selfie.json'

class Welcome extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    //left menu 
      work: false,
      blog: false,
      about: false,


    //welcome section
      aboutMe: false,
      portfolio: false,
      applications: false,
      music: false,
      resume: false,
  }

  tonyeHover(element) {
    switch(element) {

      
    }

  }

  render() {

    return (
      <div className="works">
        <Row className="py-5">
          <Col sm={12} md={5}>
            <ul className="works-list" style={{ transform: "matrix(1, 0, 0, 1, 0, 0)" }} >
              <li className="work">
                <a href="#about" className="link">
                  <h2 className="work-title">
                    About Me 
                    <span className="stroke">About Me</span>
                  </h2>
                  <div
                    className="work-info"
                  >
                    <span className="work-description">Who is Tonye Brown?</span> -{" "}
                    <span className="work-date">Introduction</span>
                  </div>
                </a>
              </li>
              <li className="work">
                <a href="#portfolio" className="link" >
                  <h2
                    className="work-title"
                  >
                    My Portfolio
                    <span className="stroke">My Portfolio</span>
                  </h2>
                  <div
                    className="work-info"
                  >
                    <span className="work-awards">
                      WEB, Mobile, Print &amp; More
                    </span>{" "}
                    -{" "}
                    <span className="work-description">
                      Samples of my work
                    </span>{" "}
                    - <span className="work-date">VIEW</span>
                  </div>
                </a>
              </li>
              <li className="work">
                <a
                  href="#apps"
                  className="link"
                >
                  <h2
                    className="work-title"
                    data-top="7812"
                  >
                    Applications<span className="stroke">Applications</span>
                  </h2>
                  <div className="work-info">
                    <span className="work-description">
                      Amazing projects I've worked on
                    </span>{" "}
                    - <span className="work-date">Experience</span>
                  </div>
                </a>
              </li>
              <li className="work">
                <a
                  href="#music"
                  className="link"
                 
                >
                  <h2
                    className="work-title"
                    data-top="7950"
                  >
                    Music<span className="stroke">Music</span>
                  </h2>
                  <div className="work-info">
                    <span className="work-description">I Make Music too</span> -{" "}
                    <span className="work-date">Listen</span>
                  </div>
                </a>
              </li>
              <li className="work">
                <a href="#resume" className="link">
                  <h2 className="work-title">
                    Resumé<span className="stroke">Resumé</span> 
                  </h2>
                  <div className="work-info">
                    <span className="work-description">Summary of Work Experience</span>{" "}
                    - <span className="work-date">VIEW</span>
                  </div>
                </a>
              </li>
            </ul>
          </Col>
          
          <Col md={7} className="px-5 pr-0 pb-5 d-sm-none d-lg-inline">
            <div className="placeholder">

            </div>
          </Col>
        </Row>
          

      </div>
    )
  }
}

export default Welcome